export enum RoleGroup {
  PRIMARY = 'primary',
}
